import React, { useState, useEffect, useRef } from 'react';

import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

const InactivityDetector = ({ timeoutDuration = 100000000 }) => {
  const [isActive, setIsActive] = useState(true);  // Track user's activity state
  const timeoutRef = useRef(null);                 // Reference to the timeout

  // Function to reset the inactivity timer
  const resetTimer = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);  // Clear the existing timer
    }

    // Start a new timer to mark inactivity
    timeoutRef.current = setTimeout(() => {
      setIsActive(false);  // Set inactive after timeout duration
    }, timeoutDuration);

    setIsActive(true);  // User is active as long as events are firing
  };

  // Set up event listeners to detect user activity
  useEffect(() => {
    const events = ['mousemove', 'keydown', 'mousedown', 'touchstart'];

    // Attach the resetTimer function to each of the activity events
    events.forEach((event) => window.addEventListener(event, resetTimer));

    // Cleanup function to remove event listeners and clear timeout on unmount
    return () => {
      events.forEach((event) => window.removeEventListener(event, resetTimer));
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return (
    <Dialog open={!isActive} onOpenChange={(open) => !open && setIsActive(true)}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Are you still here?</DialogTitle>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={() => setIsActive(true)}>
            Yes
          </Button>
          <Button variant="outline" onClick={() => setIsActive(false)} autoFocus>
            Logout
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default InactivityDetector;
